import { isDefined } from '@vueuse/core';

import { hasChangedOnlySelectedDate } from '@apps/main/new-desktop/core/stores/criteria/criteriaStore.logic';

import type {
  ItinerarySearchCriteria,
  ItinerarySearchUserCriteria,
  ItineraryWithPrice,
} from '@libs/trip-planner-interfaces';
import { SemboDate } from '@libs/sembo-dates';

export function shouldClearSingleItinerary(
  criteria: ItinerarySearchCriteria,
  previousUserCriteria: ItinerarySearchUserCriteria,
  selectedItinerary: ItineraryWithPrice | undefined
): selectedItinerary is ItineraryWithPrice {
  return (
    isDefined(selectedItinerary) &&
    !selectedItinerary.isSearched &&
    hasChangedOnlySelectedDate(criteria.userCriteria, previousUserCriteria)
  );
}

export function shouldSearchCurrentItinerary(
  currentItinerary: ItineraryWithPrice,
  selectedItinerary: ItineraryWithPrice | undefined
): selectedItinerary is ItineraryWithPrice {
  return (
    isDefined(selectedItinerary) &&
    new SemboDate(selectedItinerary.date).isSameDay(currentItinerary.date) &&
    !currentItinerary.isSearched
  );
}
